import React, { useState, useContext, useEffect } from "react";
import Modal from "common/Modal.jsx";
import ActionsContext from "common/ActionsContext";
import Fields from "./Fields";

const doesNothing = () => {};

const CreateRangeModal = ({
  doValidate = doesNothing,
  doSave = doesNothing,
  onClose = doesNothing,
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const actions = useContext(ActionsContext);
  const doClose = () => {
    setOpen(false);
    onClose();
  };
  const doOpen = () => {
    setError(null);
    setOpen(true);
  }
  useEffect(() => actions.recv("new-range", doOpen), []);
  if (open === false) {
    return null;
  }

  const handleChange = ({target}) => {
    try {
      doValidate({[target.name]: target.value})
      setError(null);
    } catch (error) {
      setError(error);
    }
  };

  const doApply = (update) => {
    try {
      doSave(update);
      doClose();
    } catch (error) {
      setError(error);
    }
    return false;
  };

  return (
    <Modal
      title="Create Range"
      superIcon="add_circle"
      large={false}
      content={() => (
        <Fields onChange={handleChange} />
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={error !== null}
      closeLabel="CANCEL"
      onClose={doClose}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};
export default CreateRangeModal;
